import { pointInPolygon } from './point-in-polygon.util';

export function isInZone(coords: [number, number], coordinates: string[][][]): boolean {
  return coordinates.some(polygon => pointInPolygon(coords, polygon));
}
